var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lootbox-selection"},_vm._l((_vm.lootboxes),function(lootbox){return _c('div',{key:lootbox.id,staticClass:"lootbox-selection__item",class:{
      active: _vm.isActiveLootbox(lootbox),
      unavailable: lootbox.quantity <= 0,
    },on:{"click":function($event){return _vm.changeLootbox(lootbox)}}},[_c('span',{staticClass:"count"},[_vm._v(_vm._s(lootbox.quantity))]),_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.lootboxThumbnail(lootbox.name),"draggable":"false"}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }